import React, { useRef, useState, useEffect } from 'react';
import api from '../../../../../api';

const LatestNewsMarquee = () => {
  const marqueeRef = useRef(null);

  const [heading, setHeading] = useState("");
  const [newsItems, setNewsItems] = useState([]);

  const BASE_URL = process.env.REACT_APP_API_URL; // your base URL

  useEffect(() => {
    const fetchMarqueeData = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/library");

        const marqueeSection = response.data.groups.find(
          group => group.marquee_section
        )?.marquee_section;

        if (marqueeSection) {
          setHeading(marqueeSection.title || "Latest News & Updates:");

          const items = marqueeSection.links?.map(item => {
            let link = item.link || "#";

            // ✅ ADD /public ONLY FOR PDF
            if (link.endsWith(".pdf")) {
              link = `${BASE_URL}/public${link}`;
            }

            return {
              text: item.text || "",
              url: link
            };
          }) || [];

          setNewsItems(items);
        }
      } catch (error) {
        console.error("Error fetching marquee data:", error);
      }
    };

    fetchMarqueeData();
  }, []);

  return (
    <section className="latest_news_section py-3">
      <div className="container">
        <div className="row align-items-center d-flex justify-content-center">
          <div className="col-md-7 col-11 p-0 p-md-auto">
            <div className="trending-carousel-container d-flex align-items-center flex-row">

              {/* MOBILE HEADING */}
              <div className="trending-label-lib me-2 d-block d-md-none">
                {heading}
              </div>

              {/* MARQUEE */}
              <marquee
                ref={marqueeRef}
                behavior="scroll"
                direction="left"
                scrollamount="6"
                onMouseOver={() => marqueeRef.current?.stop()}
                onMouseOut={() => marqueeRef.current?.start()}
              >
                {newsItems.map((item, index) => (
                  <span key={index} className="me-3 me-md-5">
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      {item.text}
                    </a>
                  </span>
                ))}
              </marquee>

              {/* DESKTOP HEADING */}
              <div className="trending-label-lib me-3 d-none d-md-block">
                {heading}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestNewsMarquee;
